export default __webpack_public_path__ + "static/media/clairefontaine11.8272e5d6.jpg";